import React from "react";

import { StatusBadgeProps } from "./statusBadgeProps";

export const RejectedStatusBadge = (props: StatusBadgeProps) => {
    const { width, height = "18", viewBox = "0 0 69 18", ...rest } = props;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox={viewBox}
            {...rest}
            data-cy="rejectedBadge"
        >
            <g
                fill="none"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
                transform="translate(-957 -10253) translate(957 10253)"
            >
                <rect
                    width="69"
                    height="18"
                    x="0"
                    y="0"
                    fill="#FE6967"
                    rx="1.966"
                ></rect>
                <path
                    fill="#FFF"
                    fillRule="nonzero"
                    d="M6 13.258V5.12h2.51c1.538 0 2.782.852 2.782 2.35 0 1.053-.668 1.82-1.635 2.113l2.263 3.674h-1.417L8.46 9.71c-.156 0-.328.005-.495.005h-.726v3.542H6zm1.25-4.555h1.37c.916-.029 1.446-.478 1.446-1.21 0-.777-.588-1.26-1.544-1.26H7.25v2.47zm6.04 4.555V5.12h5.385v1.14h-4.147v2.35h3.813v1.14h-3.813v2.338h4.147v1.169H13.29zm8.886.11c-1.618 0-2.591-1.158-2.695-2.592l1.215-.138c.069.892.53 1.578 1.48 1.578 1.134 0 1.445-.674 1.445-1.884v-4.07h-3.144V5.12h4.382v5.188c0 1.786-.76 3.058-2.683 3.058zm4.785-.11V5.12h5.385v1.14h-4.147v2.35h3.813v1.14h-3.813v2.338h4.147v1.169H26.96zm10.487.11c-2.592 0-3.853-1.895-3.853-4.182C33.595 6.895 34.845 5 37.46 5c1.613 0 2.84.795 3.478 2.292l-1.163.46c-.34-1.122-1.186-1.571-2.326-1.571-1.803 0-2.626 1.272-2.626 2.954 0 1.727.783 3.052 2.626 3.052 1.128 0 1.888-.461 2.35-1.595l1.15.472c-.644 1.497-1.894 2.303-3.5 2.303zm6.622-.11V6.232h-2.649V5.121h6.53v1.111h-2.643v7.026H44.07zm5.212 0V5.12h5.384v1.14H50.52v2.35h3.812v1.14H50.52v2.338h4.146v1.169h-5.384zm7.227 0V5.12h2.303c2.747 0 4.21 1.486 4.21 4.129 0 2.54-1.503 4.008-4.221 4.008h-2.292zm1.238-1.14h.938c1.918 0 3.098-.812 3.098-2.92 0-2.044-.892-2.937-2.988-2.937h-1.048v5.857z"
                ></path>
            </g>
        </svg>
    );
};
